<template>
  <div>
    <!-- 分割線區塊 -->
    <div class="cut_off"></div>

    <!-- 內容區塊 -->
    <div class="audit_maxbox">

      <div class="audit">
        <div class="audit_title">
          - 修改結算資訊 -
        </div>
        <!-- 內容 -->
        <div class="audit_content">
          <h1>資料已送出，請耐心等待審核^ ^</h1>
          <!-- 4位數 -->
          <div class="audit_wait" v-show="auditTF">
            <p>您登記的銀行帳號將會收到新台幣1元整的驗證匯款</p>
            <p class="audit_p">該筆轉帳資料帶有一組<span>4位數</span>的轉帳備注（附言）驗證碼</p>
            <p>請刷存折或登入網銀查看該組驗證碼後填入下方空格內</p>
            <el-input class="audit_input" v-model="auditVal" maxlength="4" clearable></el-input>
            <el-button type="primary" @click="waitShowBtns()">發送驗證</el-button>
            <p class="audit_service">請耐心等待驗證匯款，24小時後若仍未收到驗證匯款，請聯絡<span>線上客服</span></p>
          </div>
          <!-- 發送成功 -->
          <div class="audit_wait" v-show="!auditTF">
            <p>等待的時間歡迎逛逛<span class="audit_go_home" @click="goHome()">台易購商城</span>❤</p>
            <p class="wait_p">萬件好物等著您，也別忘了確認最新活動訊息哦！</p>
          </div>
      </div>

      <!-- audit -->
    </div>
      
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Audit',
  props: {
  },
  data() {
    return {
      auditVal: '',
      auditTF: false,
      // 用來判斷：
      twoVal: '',
    }
  },
  components: {

  },
  computed: {

  },
  methods: {
    goHome(){
      // this.$router.push("/");
    },
    // 驗證：
    waitShowBtns() {

      if(this.auditTF){
        // 判斷
        if( this.auditVal == this.twoVal ){

          this.$message({
            showClose: true,
            message: '驗證成功，歡迎您！',
            type: 'success',
            duration: 1000
          });
          // 提交：
          axios.get(this.$store.state.axiosLoginBankSubUrl, {
            params:{
              uid: this.$store.state.uid
            }
          }).then((res) => {
            // console.log(res.data);
            // 判斷是否操作成功：
            if(res.data.status){
              // 修改成功：
              localStorage.removeItem('Baudit');
              this.$router.push("/");
              this.$store.commit('changeBank',0);
            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'error',
                duration: 1000
              }); 
            }

          })

        } else {
          this.$message({
            showClose: true,
            message: '驗證錯誤，請重新輸入',
            type: 'error',
            duration: 1000
          });  

        }

      }



      // if(this.$store.state.number != null){

      //   if(this.auditVal == this.$store.state.number){
      //     axios.get(this.$store.state.axiosAuditVerificationUrl, {
      //         params:{
      //           type: 1,
      //           uid: this.$store.state.registerList.uid
      //         }
      //     }).then((res) => {
      //       // console.log(res);
      //     })
      //     this.$message({
      //       showClose: true,
      //       message: '驗證成功，歡迎您！',
      //       type: 'success',
      //       duration: 1000
      //     });
      //     this.$router.push("/agreement");

      //   } else {
      //     this.$message({
      //       showClose: true,
      //       message: '驗證碼錯誤，請重新輸入',
      //       type: 'error',
      //       duration: 1000
      //     });
      //   }

      // }
    },
  },
  created() {
    if(this.$store.state.branchChange == '2'){
      this.auditTF = true;
      // 自動獲取：
      axios.get(this.$store.state.axiosLoginBankUrl, {
        params:{
          uid: this.$store.state.uid
        }
      }).then((res) => {
        this.twoVal = res.data.message.fy;
        // console.log(res.data.message.fy);
      })

    } else {
      this.auditTF = false;

    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cut_off {
  height: 4px;
  background: #e73262;
}
/* wait */
  .audit_maxbox {
    display: flex;
    align-items: center;
    min-height: 600px;
  }
  .audit {
      box-sizing: border-box;
      border: 2px solid #bbbbbb;
      font-size: 17px;
      color: #777777;
      overflow: hidden;
      width: 970px;
      margin: 0 auto;
      margin-bottom: 42px;
    }
  .audit_title {
    height: 55px;
    line-height: 55px;
    background: #f2f2f2;
    text-align: center;
    font-weight: bold;
  }
  .audit_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .audit_content > h1 {
    font-size: 29px;
    font-weight: bold;
    margin-top: 36px;
    margin-bottom: 40px;
  }
  .audit_content > h1 > span {
    color: #7c9cec;
    display: inline-block;
    padding: 16px 0;
    border-bottom: 3px solid #7c9cec;
  }
  .audit_content p {
    font-size: 11px;
  }
  .audit_content .audit_p {
    margin: 26px 0;
  }
  .audit_p span {
    color: #e73262;
  }
  .audit_wait {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .audit_input {
    width: 180px;
    margin: 36px 0;
  }
  .audit_service {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .audit_service span {
    color:#9fb5f0;
  }
  .audit_go_home {
    color:#9fb5f0; 
    cursor: pointer;
  }
  .wait_p {
    margin-top: 26px;
    margin-bottom: 48px;
  }
/* defeated */
  .audit_defeated {
    box-sizing: border-box;
    font-size: 13px;
    border: 2px solid #bbbbbb;
    width: 443px;
    min-height: 183px;
    margin-bottom: 36px;
    padding: 12px;
  }
  .audit_defeated dt{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .audit_defeated dt {
    font-weight: bold;
  }
  .audit_defeated dt span {
    font-size: 30px;
  }
  .audit_defeated dd {
    text-indent: 18px;
    margin-bottom: 16px;
  }
</style>
